// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__4qq7w","filters_close":"FiltersBlock_filters_close__-UWQz"};